import { css, keyframes } from '@emotion/react';

const shine = keyframes`
  to {
    background-position:
        100% 0,
        0px 0,
        0px 40px,
        0px 80px,
        0px 120px;
    }
`;

function skeleton(sizes, spacing) {
  return css`
    margin: var(--spacing-300) 0;
    width: 100%;
    min-height: 550px;

    background-image: linear-gradient(
        100deg,
        rgba(255, 255, 255, 0),
        rgba(255, 255, 255, 0.5) 50%,
        rgba(255, 255, 255, 0) 80%
      ),
      ${sizes
        .map(([, y]) => `linear-gradient(lightgray ${y}px, transparent 0)`)
        .join(',')};

    background-repeat: repeat-y;

    background-size:
      50px ${spacing}px,
      ${sizes.map(([x]) => `${x}px ${spacing}px`).join(',')};

    background-position:
      0 0,
      /* highlight */ 0px 0,
      0px 40px,
      0px 80px,
      0px 120px;

    animation: ${shine} 1.3s infinite;

    @media (prefers-reduced-motion) {
      animation: ${shine} 5s infinite;
    }
  `;
}

export { skeleton };
